import React, { lazy } from 'react'

const GeneralDOMain = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralDOModule/GeneralDOMain'
  ).then(module => ({
    default: module.GeneralDOMain,
  }))
)

const GeneralDOForm = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralDOModule/GeneralDOFormV2'
  ).then(module => ({
    default: module.GeneralDOFormV2,
  }))
)

const PDFPreviewGP = lazy(() =>
  import(
    '@account-root/procurement-react/src/components/PDFTemplate/PDFPreviewGP'
  ).then(module => ({
    default: module.PDFPreviewGP,
  }))
)

const GeneralDODetail = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralDOModule/GeneralDODetail'
  ).then(module => ({
    default: module.GeneralDODetail,
  }))
)

const GRNEditListingReport = lazy(() =>
  import(
    '@account-root/procurement-react/src/containers/GeneralPurchaseModule/GeneralDOModule/GRNEditListingReport'
  ).then(module => ({
    default: module.GRNEditListingReport,
  }))
)

const generalDORoutes = [
  {
    props: { exact: true, path: '/general-purchase/:CompanyID/delivery-order' },
    component: <GeneralDOMain />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/delivery-order/add',
    },
    component: <GeneralDOForm mode="add" />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/delivery-order/edit/:DOHeaderID',
    },
    component: <GeneralDOForm mode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/delivery-order/resubmit/:DOHeaderID',
    },
    component: <GeneralDOForm mode="resubmit" />,
  },
  {
    props: {
      exact: true,
      path: '/general-purchase/:CompanyID/delivery-order/detail/:DOHeaderID',
    },
    component: <GeneralDODetail />,
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/delivery-order/detail/:DOHeaderID/preview',
    },
    component: (
      <PDFPreviewGP
        accountType="/"
        docType="delivery-order"
        backPath="delivery-order"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/delivery-order/detail/:DOHeaderID/grn-edit-listing',
    },
    component: <GRNEditListingReport />,
  },
]

export default generalDORoutes
